import { Component, OnInit } from '@angular/core';
import { HomePageService } from '../homepage.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  privacyPolicy: string;

  constructor(private homePageService: HomePageService) { }

  ngOnInit(): void {
    this.getTermsAndPrivacyData();
  }

  getTermsAndPrivacyData() {
    this.homePageService.termConditionAndPrivacyPolicy().subscribe((data: any) => {
      // this.termsAndConditions = data.termAndPrivacyData.termCondition;
      this.privacyPolicy = data.termAndPrivacyData.privacyPolicy;
      // this.cancellationPolicy = data.termAndPrivacyData.cancellationPolicy;
    });
  }

}
